
























































































































import { Vue, Component, Watch } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import { BreadcrumbData } from '@/componentsV2/molecules/Breadcrumbs/Breadcrumbs.vue';
import CampaignSettings, {
  CampaignSettingsInputProps
} from '@/componentsV2/organisms/SocialRewards/CampaignSettings.vue';
import CampaignOverview, {
  SocialOverviewFieldProp
} from '@/componentsV2/organisms/SocialRewards/CampaignOverview.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import LinkIcon from '@/components/icons/Link.vue';
import FacebookShareIcon from '@/components/icons/social-media/FacebookShare.vue';
import FacebookFollowIcon from '@/components/icons/social-media/FacebookFollow.vue';
import InstagramFollowIcon from '@/components/icons/social-media/InstagramFollow.vue';
import TwitterFollowIcon from '@/components/icons/social-media/TwitterFollow.vue';
import TwitterShareIcon from '@/components/icons/social-media/TwitterShare.vue';
import YouTubeSubscribeIcon from '@/components/icons/social-media/YouTubeSubscribe.vue';
import TikTokFollowIcon from '@/components/icons/social-media/TikTokFollow.vue';
import PinterestFollowIcon from '@/components/icons/social-media/PinterestFollow.vue';
import FacebookIcon from '@/components/icons/social-media/Facebook.vue';
import InstagramIcon from '@/components/icons/social-media/Instagram.vue';
import TwitterIcon from '@/components/icons/social-media/Twitter.vue';
import TikTokIcon from '@/components/icons/social-media/TikTok.vue';
import PinterestIcon from '@/components/icons/social-media/Pinterest.vue';
import YouTubeIcon from '@/components/icons/social-media/YouTube.vue';
import AtSign from '@/components/icons/AtSign.vue';
import {
  ESocialRewards,
  socialProfilesDictionary,
  SocialRewardCreateDataDictionary,
  SocialRewardCreateDataType
} from './SocialRewardsEnum';
import SocialRewardsService from '@/api/SocialRewardsService';
import { SocialRewardCampaign } from '@/models/social-rewards';
import HowManyCoinsShouldIgive from '@/componentsV2/molecules/HowManyCoinsShouldIgive/HowManyCoinsShouldIgive.vue';
import { TextField } from '@/components/atoms';
import SocialLinks from '@/utils/socialLinks';
import Close from '@/components/icons/Close.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import { handleCompleteTask } from '@/utils/start-guide';
import { EStartGuideTaskSlug } from '@/models/start-guide';

type ActionType = 'create' | 'edit';

@Component({
  components: {
    Page,
    CampaignSettings,
    CampaignOverview,
    CoinsIcon,
    FacebookShareIcon,
    FacebookFollowIcon,
    InstagramFollowIcon,
    TwitterFollowIcon,
    TwitterShareIcon,
    YouTubeSubscribeIcon,
    TikTokFollowIcon,
    PinterestFollowIcon,
    LinkIcon,
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    TikTokIcon,
    PinterestIcon,
    YouTubeIcon,
    HowManyCoinsShouldIgive,
    TextField,
    AtSign,
    Close,
    FilledButton
  },
  $_veeValidate: { validator: 'new' }
})
export default class ScoalRewardsCreateCampaign extends Vue {
  socialRewardService = new SocialRewardsService();
  socialType = ESocialRewards.FACEBOOK_SHARE;
  pageDescriptions: SocialRewardCreateDataType =
    SocialRewardCreateDataDictionary[ESocialRewards.FACEBOOK_SHARE];
  campaign!: SocialRewardCampaign;
  inputValue = '';
  coinInputValue = '';
  toggleActive: boolean = false;
  extraInputProps: CampaignSettingsInputProps = {
    value: '',
    type: 'text',
    maxlength: '40'
  };
  overviewFields: SocialOverviewFieldProp[] = [];
  socialLinks = new SocialLinks();
  actionType: ActionType = 'create';

  get breadcrumbs() {
    const breadcrumbList: BreadcrumbData[] = [
      {
        label: 'Social rewards campaign',
        path: '/social-rewards'
      },
      {
        label:
          this.actionType === 'create' ? 'Create new campaign' : 'Edit campaign'
      }
    ];

    return breadcrumbList;
  }

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  get businessCurrencyName() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencyShorthand;
  }

  get showUserOnly() {
    return [
      ESocialRewards.INSTAGRAM_FOLLOW,
      ESocialRewards.TWITTER_FOLLOW
    ].includes(this.socialType);
  }

  @Watch('inputValue')
  updateInputOverview() {
    this.updateOverview(0, this.inputValue);
  }
  @Watch('coinInputValue')
  updateCoinOverview() {
    this.updateOverview(
      this.overviewFields.length - 1,
      `${this.coinInputValue || 0} Coins per user`
    );
  }
  @Watch('extraInputProps.value')
  updateExtraInputOverview() {
    this.updateOverview(1, this.extraInputProps.value);
  }

  onHideTip() {
    const { tippyRef }: { tippyRef?: any } = this.$refs;
    tippyRef.tip.hide();
  }

  updateOverview(index: number, value: string) {
    this.overviewFields[index].label =
      value || this.pageDescriptions.campaignOverview.fields[index].label;
  }

  changeExtraInput(value: string) {
    this.extraInputProps.value = value;
  }

  getSocialTypeParam() {
    const { social, action } = this.$route.params;
    this.socialType = social as ESocialRewards;
    this.actionType = action as ActionType;
  }

  getSocialRewardsCampaigns() {
    return this.socialRewardService.getSocialRewardsCampaigns();
  }

  getPageDescription() {
    this.pageDescriptions = SocialRewardCreateDataDictionary[this.socialType];
    if (
      this.pageDescriptions.campaignSettings.showExtraInput &&
      this.pageDescriptions.campaignSettings.extraInputProps
    ) {
      this.extraInputProps = {
        ...this.extraInputProps,
        ...this.pageDescriptions.campaignSettings.extraInputProps
      };
    }
    this.overviewFields = JSON.parse(
      JSON.stringify(this.pageDescriptions.campaignOverview.fields)
    );
  }

  async getCampaing() {
    if (this.actionType === 'edit') {
      let currentCampaign = this.$store.getters[
        'socialRewards/getCurrentCapaign'
      ](this.socialType) as SocialRewardCampaign | undefined;

      if (!currentCampaign) {
        const {
          data: socialRewardsCampaigns
        } = await this.getSocialRewardsCampaigns();
        this.$store.dispatch(
          'socialRewards/SET_SOCIAL_CAMPAIGNS',
          socialRewardsCampaigns
        );

        currentCampaign = socialRewardsCampaigns.find(
          campaign => campaign.type === this.socialType
        );
      }
      if (currentCampaign) {
        this.campaign = currentCampaign;
        this.toggleActive = currentCampaign.status === 'active';

        this.setInputValues(currentCampaign);
      }
    }
    if (
      [ESocialRewards.FACEBOOK_SHARE, ESocialRewards.TWITTER_SHARE].includes(
        this.socialType
      ) &&
      this.actionType === 'create'
    ) {
      const webSiteUrl = this.$store.getters['socialRewards/getWebSiteUrl'] as
        | string
        | undefined;
      this.inputValue = webSiteUrl || '';
    }
  }

  init() {
    this.getSocialTypeParam();
    this.getPageDescription();

    this.getCampaing();
  }

  mounted() {
    this.init();
  }

  async validate() {
    let validationResult = await this.$validator.validate();

    if (!validationResult) {
      this.$notification('Please fill the highlighted fields below', 'error');
      return validationResult;
    }

    const urlIsValid = this.socialLinks.isValid(
      socialProfilesDictionary[this.socialType],
      this.inputValue
    );

    if (!urlIsValid) {
      this.$validator.errors.add({
        field: 'url-input',
        msg: 'Invalid Address'
      });
      this.$notification(
        'Please fill in the highlighted field with a valid url',
        'error'
      );
    }
    return urlIsValid;
  }

  back() {
    this.$router.push('/social-rewards');
  }

  async submit() {
    this.$showLoaderWithLocker();
    const isValid = await this.validate();
    if (!isValid) {
      this.$hideLoader();
      return;
    }

    const message =
      (this.pageDescriptions.campaignSettings.showExtraInput &&
        this.extraInputProps.value) ||
      undefined;
    const campaignData: SocialRewardCampaign = {
      status: 'active',
      coins: Number(this.coinInputValue),
      type: this.socialType,
      metadata: {
        url: this.socialLinks.sanitize(
          socialProfilesDictionary[this.socialType],
          this.inputValue
        ),
        message
      }
    };

    this.campaign = campaignData;

    if (this.actionType === 'edit') {
      campaignData.status = this.toggleActive ? 'active' : 'inactive';
      const response = await this.socialRewardService.updateSocialRewardCampaign(
        campaignData
      );
      this.$hideLoader();
    } else {
      const response = await this.socialRewardService.createSocialRewardCampaign(
        campaignData
      );

      if (response.status === 201) {
        this.$hideLoader();

        handleCompleteTask(EStartGuideTaskSlug.SOCIAL_REWARDS);

        const query = this.$route.query;

        if (query.start_guide_task) {
          const taskSlug = query.start_guide_task.toString();

          if (taskSlug) {
            this.$router.push('/home');

            return;
          }
        }
      }
    }
    this.back();
  }

  setInputValues(campaign: SocialRewardCampaign) {
    const { metadata, coins = '' } = campaign;
    this.coinInputValue = String(coins);

    if (metadata) {
      const { url = '', message = '' } = metadata;
      this.inputValue = this.showUserOnly
        ? this.socialLinks.getProfileId(
            socialProfilesDictionary[this.socialType],
            url
          )
        : url;
      this.extraInputProps.value = message;
    }
  }

  onChange() {
    this.toggleActive = !this.toggleActive;
  }

  onDiscardChangesClick() {
    this.setInputValues(this.campaign);
    this.toggleActive = this.campaign.status === 'active';
  }
}
